/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';

export const LinkButtonTestId = 'LinkButton-input';

export type LinkButtonProps = {
  children: React.ReactNode | string;
  onClick: (e: React.MouseEvent) => void;
  toolTipKey: string;
  btnColor?: string;
  disableActionButton?: boolean;
  toolTipText?: string;
  dataTestId?: string;
};

const LinkButton: React.FC<LinkButtonProps> = ({
  children,
  onClick,
  btnColor,
  disableActionButton,
  toolTipText,
  toolTipKey,
  dataTestId,
}: LinkButtonProps) => {
  return (
    <div
      id={`LinkButtonWithToolTip-${toolTipKey}`}
      data-tip
      data-tooltip-id={`SummaryToolTip-${toolTipKey}`}
      data-tooltip-content={toolTipText}
      data-testid="link-button-with-tool-tip"
      data-tooltip-float
      data-tooltip-place="top"
    >
      <button
        disabled={disableActionButton}
        type="button"
        className={`${
          btnColor || ''
        } background-transparent link-input text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150`}
        onClick={onClick}
        data-testid={dataTestId || LinkButtonTestId}
      >
        {children}
      </button>
      {toolTipText && <ReactTooltip id={`SummaryToolTip-${toolTipKey}`} />}
    </div>
  );
};

export default LinkButton;
